'use strict';

bbw.model.FeedItemCollection = bbw.model.PostCollection.extend({

    _fetchViaApi: function(cfg) {
        if (cfg.global) {
            var args = angular.copy(cfg);
            delete cfg.global;
            return this._loadFromApi('get', 'feed/global', args);
        } else {
            return this._loadFromApi('get', 'feed', cfg);
        }
    }

});